import React from "react";

const Edit = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="11.285" height="11.285" viewBox="0 0 11.285 11.285">
			<path
				id="icons8-edit"
				d="M12.935,2.35a1.194,1.194,0,0,0-1.688,0l-.039.039-.007,0L2.565,11.029a.254.254,0,0,0-.063.11l-.493,1.837a.245.245,0,0,0,.237.309.239.239,0,0,0,.063-.009l1.837-.493a.247.247,0,0,0,.11-.064l8.635-8.634a.051.051,0,0,0,.006-.01l.037-.037A1.192,1.192,0,0,0,12.935,2.35Zm-.347.347a.7.7,0,0,1,0,.995l-.21.21-.995-.995.21-.21a.7.7,0,0,1,.995,0ZM2.885,11.6l.8.8-1.088.292Z"
				transform="translate(-2 -2)"
				fill="#fff"
			/>
		</svg>
	);
};

export default Edit;
